import { render, staticRenderFns } from "./peopleSecurity.vue?vue&type=template&id=5a06e00c&scoped=true"
import script from "./peopleSecurity.vue?vue&type=script&lang=js"
export * from "./peopleSecurity.vue?vue&type=script&lang=js"
import style0 from "./peopleSecurity.vue?vue&type=style&index=0&id=5a06e00c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a06e00c",
  null
  
)

export default component.exports